import { IModule } from 'angular';
import { NavigationService } from './navigationSrvc';

export function registerServices(module: IModule) {
    // TODO: export and register the remaining JS services here
    return module.service('navigationService', NavigationService);
}

export * from './navigationSrvc';
